<template>
  <div id="menu">
    <div class="grid d-flex d-md-flex justify-content-between py-2 pt-md-3 pb-md-3">
      <router-link to="/" class="d-none d-md-block ml-md-4">
        <img src="https://cdn.outleap.de/f84HLYRpmHhZDP3AEriTamtkVEdA7yDu7eiLNpv56Ws/da:t/dpr:2/rt:fill/w:160/czM6Ly9jZG4tb3V0bGVhcC9qYWdkbmV3cy9sb2dvcy9vcmFuZ2UucG5n" width="160" lass="mx-auto d-block">
      </router-link>

      <router-link to="/" class="d-block d-md-none ml-2 ml-md-4 align-self-center">
        <img src="https://cdn.outleap.de/pd0-YvM8Sq2_wlWbnPanBm90Z_0XwARm55lP1TR0J_s/da:t/dpr:2/rt:fill/w:120/czM6Ly9jZG4tb3V0bGVhcC9qYWdkbmV3cy9sb2dvcy9vcmFuZ2UucG5n" width="120" class="mx-auto d-block">
      </router-link>

<!--       <form @submit.prevent="search()" class="w-100 px-2 px-md-5 mt-md-0">
        <div class="input-group">
          <input type="text" class="form-control form-control-lg" placeholder="Suchen ..." v-model="q">
          <div class="input-group-append">
            <button type="submit" class="btn btn-primary btn-lg">
              <fa-icon :icon="['fal', 'search']" color="white"></fa-icon>
            </button>
          </div>
        </div>
      </form> -->

      <div class="mr-4 text-nowrap d-none d-md-block">
        <a href="https://apps.apple.com/us/app/jagdnews/id1483200647?l=de&ls=1" target="_blank">
          <img src="https://cdn.outleap.de/-5_qJCRzlw4Nv5tkvxmTJHAE3SupbtzI75MgHKc_gw8/da:t/dpr:2/h:48/rt:fill/czM6Ly9jZG4tb3V0bGVhcC9qYWdkbmV3cy9hcHBzL2lvcy5wbmc" alt="iOS" height="42">
        </a>

        <a href="https://play.google.com/store/apps/details?id=de.jagdnews.app" target="_blank">
          <img src="https://cdn.outleap.de/wnCfyQEwbKeTDDegCTYBBCjAfsThnHXF2M1TfCHClIs/da:t/dpr:2/h:48/rt:fill/czM6Ly9jZG4tb3V0bGVhcC9qYWdkbmV3cy9hcHBzL2FuZHJvaWQucG5n" alt="Android" height="42">
        </a>
      </div>
    </div>

    <div class="slider d-flex d-xl-none mt-1 px-1 pt-2 pb-1">
      <router-link class="text-muted mr-3" to="/" exact>
        <fa-icon :icon="['fal', 'newspaper']" class="mr-2"></fa-icon>
        Das Neueste
      </router-link>
      <router-link class="text-muted mr-3" to="/top">
        <fa-icon :icon="['fal', 'heart-rate']" class="mr-2"></fa-icon>
        Top Stories
      </router-link>
      <router-link class="text-muted mr-3" to="/favorites">
        <fa-icon :icon="['fal', 'bookmark']" class="mr-2"></fa-icon>
        Mein Merkzettel
      </router-link>
    </div>

    <div class="slider sources border-top pt-2 pb-1 d-flex d-xl-none mt-1 px-1">
      <router-link class="text-muted" to="/" exact>
        <span class="mr-2">
          <fa-icon :icon="['fal', 'circle']"></fa-icon>
          <fa-icon :icon="['fal', 'dot-circle']"></fa-icon>
        </span>
        Alle Quellen
      </router-link>

      <router-link class="text-muted ml-3" :to="'/sources/' + source.id" v-for="source in sources" :key="source.id">
        <span class="mr-2">
          <fa-icon :icon="['fal', 'circle']"></fa-icon>
          <fa-icon :icon="['fal', 'dot-circle']"></fa-icon>
        </span>
        {{ source.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    data () {
      return {
        q: ''
      };
    },
    props: {
      sources: {
        type: Array,
        default () {
          return [];
        }
      }
    },
    mounted () {
      // this.setQ();
    },
    watch: {
      '$route' () {
        if (this.$route.path !== '/search') {
          this.q = '';
        }
      }
    },
    // methods: {
    //   setQ () {
    //     if (this.$route.query.q) {
    //       this.q = this.$route.query.q;
    //     }
    //   },
    //   search () {
    //     if (this.q.replace(/\s/g, '') === '') {
    //       return;
    //     }
        
    //     this.$router.push({
    //       path: '/search',
    //       query: Object.assign({}, this.$route.query, { q: this.q, page: 1 })
    //     });
    //   }
    // }
  };
</script>

<style lang="less" scoped>
  #menu {
    background-color: #F2F2F2;
    border-bottom: 1px solid #E8E8E8;
  }

  .slider {
    white-space: nowrap;
    display: block;
    overflow-x: scroll;
    overflow-y: visible;
    margin: 5px 10px;

    a {
      &.active.text-muted {
        color: #FF5A4B !important;
      }
    }
  }

  .sources.slider {
    // background-color: #eee;
    a {
      svg {
        display: none !important;

        &:nth-of-type(1) {
          display: inline-block !important;
        }
      }

      &.active {
        svg {
          &:nth-of-type(1) {
            display: none !important;
          }

          &:nth-of-type(2) {
            display: inline-block !important;
          }
        }
      }
    }
  }
</style>
